<p-toast />
<p-confirmDialog #cd appendTo="body" (onHide)="close()">
  <ng-template pTemplate="header">
    <p
      class="font-bold text-xl"
      [innerHTML]="header | highlight : '¡Importante!'"
    ></p>
  </ng-template>
  <ng-template pTemplate="footer">
    @if(cancelButton) {
    <div class="flex justify-between w-full">
      <button
        pRipple
        class="bg-[#2c63aa] text-white p-2 rounded-md shadow-md"
        (click)="cd.onReject()"
      >
        Cancelar
      </button>
      <button
        pRipple
        class="p-2 text-[#2c63aa] font-bold rounded-md shadow-md"
        (click)="cd.onAccept()"
      >
        Confirmar
      </button>
    </div>
    } @else {
    <button
      pRipple
      class="p-2 text-[#2c63aa] font-bold rounded-md shadow-md"
      (click)="cd.onAccept()"
    >
      Confirmar
    </button>
    }
  </ng-template>
</p-confirmDialog>
